const svgs = './svgs';
const images = './images';
const jsons = './jsons';

const SVGS = {
    //Header
    Logo: require(`${svgs}/abeauty-logo.svg`),
    Account: require(`${svgs}/account-avt.svg`),
    LoginIcon: require(`${svgs}/icon-login-button.svg`),
    PhoneIcon: require(`${svgs}/icon-phone.svg`),

    //Nav mobile
    IconHome: require(`${svgs}/icon-home.svg`),
    IconHomeOn: require(`${svgs}/icon-home-on.svg`),

    IconCollection: require(`${svgs}/icon-collection.svg`),
    IconCollectionOn: require(`${svgs}/icon-collection-on.svg`),

    IconViewGrid: require(`${svgs}/icon-view-grid.svg`),
    IconViewGridOn: require(`${svgs}/icon-view-grid-on.svg`),

    IconBell: require(`${svgs}/icon-bell.svg`),
    IconBellOn: require(`${svgs}/icon-bell-on.svg`),

    IconPerson: require(`${svgs}/icon-person.svg`),
    IconPersonOn: require(`${svgs}/icon-person-on.svg`),

    IconSkin: require(`${svgs}/icon-skin.svg`),
    IconSkinOn: require(`${svgs}/icon-skin-on.svg`),

    // Footer
    IconLocation: require(`${svgs}/icon-location.svg`),
    IconPhone: require(`${svgs}/icon-phone-num.svg`),
    IconEmail: require(`${svgs}/icon-email.svg`),
    IconTimer: require(`${svgs}/icon-timer.svg`),
    IconTimerBlack: require(`${svgs}/icon-timer-black.svg`),
    IconBodyPeople: require(`${svgs}/icon-body-people.svg`),
    IconFB: require(`${svgs}/icon-facebook.svg`),
    IconYoutube: require(`${svgs}/icon-youtube.svg`),
    IconIns: require(`${svgs}/icon-instagram.svg`),
    IconZalo: require(`${svgs}/icon-zalo.svg`),
    LogoHitek: require(`${svgs}/hitek-logo.svg`),
    LogoCongThuong: require(`${svgs}/logo-congthuong.svg`),

    // Card About
    IconPeople: require(`${svgs}/icon-people.svg`),
    IconPeopleSelected: require(`${svgs}/icon-people-selected.svg`),
    IconWallet: require(`${svgs}/icon-wallet.svg`),
    IconWalletSelected: require(`${svgs}/icon-wallet-selected.svg`),
    IconBill: require(`${svgs}/icon-bill.svg`),
    IconBillSelected: require(`${svgs}/icon-bill-selected.svg`),
    IconSchedule: require(`${svgs}/icon-schedule-pick.svg`),
    IconScheduleSelected: require(`${svgs}/icon-schedule-pick-selected.svg`),
    IconFavorite: require(`${svgs}/icon-favorite.svg`),
    IconNoti: require(`${svgs}/icon-noti.svg`),
    IconDollar: require(`${svgs}/icon-dollar.svg`),
    IconTopUp: require(`${svgs}/icon-top-up.svg`),

    // Arrow
    IconArrowRight: require(`${svgs}/icon-arrow-right.svg`),
    IconArrowDown: require(`${svgs}/icon-arrow-down.svg`),
    IconArrowDownSelected: require(`${svgs}/icon-arrow-down-selected.svg`),
    IconArrowLeft: require(`${svgs}/icon-arrow-left.svg`),
    IconArrowUpSelected: require(`${svgs}/icon-arrow-up-selected.svg`),
    IconArrowRightBlack: require(`${svgs}/icon-arrow-right-black.svg`),
    IconArrowChecked: require(`${svgs}/icon-arrow-checked.svg`),

    // TopUp Page
    BannerTopUp: require(`${svgs}/banner.svg`),
    BackgroundWalletTopUp: require(`${svgs}/background-wallet-top-up.svg`),
    IconWalletTabAmount: require(`${svgs}/icon-wallet-tab-amount.svg`),

    // History TopUp Page
    IconProcessTopUp: require(`${svgs}/icon-process-top-up.svg`),
    IconSuccessTopUp: require(`${svgs}/icon-success-top-up.svg`),
    IconRejectTopUp: require(`${svgs}/icon-reject-top-up.svg`),

    IconChangePassSuccess: require(`${svgs}/icon-change-pass-success.svg`),
    IconLogOut: require(`${svgs}/icon-log-out.svg`),

    // Contact Page
    BackgroundFormContact: require(`${svgs}/background-form-contact.svg`),
    ImageFormContact: require(`${svgs}/image-form-contact.svg`),
    IconLocationContact: require(`${svgs}/icon-location-contact.svg`),
    IconPhoneContact: require(`${svgs}/icon-phone-contact.svg`),
    IconEmailContact: require(`${svgs}/icon-email-contact.svg`),
    IconMXHContact: require(`${svgs}/icon-mxh-contact.svg`),
    IconFBContact: require(`${svgs}/icon-fb-contact.svg`),
    IconZaloContact: require(`${svgs}/icon-zalo-contact.svg`),
    IconYoutubeContact: require(`${svgs}/icon-youtube-contact.svg`),
    IconInsContact: require(`${svgs}/icon-ins-contact.svg`),

    IconNoService: require(`${svgs}/icon-no-service.svg`),
    IconStatusDone: require(`${svgs}/icon-status-done.svg`),
    IconStatusCancel: require(`${svgs}/icon-status-cancel.svg`),
    IconStatusUnfinished: require(`${svgs}/icon-status-unfinished.svg`),

    IconDownloadQR: require(`${svgs}/icon-download-qr.svg`),
    IconLike: require(`${svgs}/icon-like.svg`),
    IconLikeSelected: require(`${svgs}/icon-like-selected.svg`),
    IconDislike: require(`${svgs}/icon-dislike.svg`),
    IconDislikeSelected: require(`${svgs}/icon-dislike-selected.svg`),
    IconStepService: require(`${svgs}/icon-step-service.svg`),
    IconClock: require(`${svgs}/icon-clock.svg`),
    IconItemLogOut: require(`${svgs}/icon-logout.svg`),

    CheveronDown: require(`${svgs}/cheveron-down.svg`),
    CheveronUp: require(`${svgs}/cheveron-up.svg`),
    IconClose: require(`${svgs}/icon-close.svg`),

    IconSlideBar: require(`${svgs}/icon-nav-slidebar.svg`),

    IconNotiCancel: require(`${svgs}/icon-noti-cancel.svg`),

    IconServices: require(`${svgs}/icon-services.svg`),
    IconPeoples: require(`${svgs}/icon-peoples.svg`),

    // Products
    IconSub: require(`${svgs}/icon-sub.svg`),
    IconPlus: require(`${svgs}/icon-plus.svg`),
    ImageSaleProducts: require(`${svgs}/image-sale-products.svg`),
    ImageAddCard: require(`${svgs}/image-add-cart.svg`),
    ImageSwitch: require(`${svgs}/icon-switch-vertical.svg`),
    ImageChevronDown: require(`${svgs}/icon-chevron-down.svg`),
    ImageAdjustments: require(`${svgs}/icon-adjustments.svg`),
    ImageChevronRight: require(`${svgs}/icon-chevron-right.svg`),
    ImageSearch: require(`${svgs}/icon-search.svg`),
    ImageChevronLeft: require(`${svgs}/icon-chevron-left.svg`),

    // Cart
    IconCart: require(`${svgs}/icon-cart.svg`),

    IconCard: require(`${svgs}/icon-card.svg`),
    IconCardSelected: require(`${svgs}/icon-card-selected.svg`),

    IconComboService: require(`${svgs}/icon-combo-service.svg`),
    IconComboServiceSelected: require(`${svgs}/icon-combo-service-selected.svg`),

    IconSpecialRequest: require(`${svgs}/icon-special-request.svg`),

    IconCamera: require(`${svgs}/icon-camera.svg`),
    IconSkinScreening: require(`${svgs}/icon-skin-screening.svg`),

    IconBranch: require(`${svgs}/icon-branch.svg`),

    IconChecked: require(`${svgs}/icon-checked.svg`),

    IconDownLineCollab: require(`${svgs}/icon-downline-collab.svg`),
    IconDownLineCollabSelected: require(`${svgs}/icon-downline-collab-selected.svg`),

    IconQRCode: require(`${svgs}/icon-qr-code.svg`),
    IconQRCodeSelected: require(`${svgs}/icon-qr-code-selected.svg`),

    IconShare: require(`${svgs}/icon-share.svg`),

    ImageFashionMockup: require(`${svgs}/image-fashion-mockup.svg`),
    IconScheduleWhite: require(`${svgs}/icon-schedule.svg`),
    IconFollowingProcess: require(`${svgs}/icon-following-process.svg`),
    IconEvaluate: require(`${svgs}/icon-evaluate.svg`),
    IconTipsBeauty: require(`${svgs}/icon-tips-beauty.svg`),
    IconCartWhite: require(`${svgs}/icon-cart-white.svg`),
    IconCTVWhite: require(`${svgs}/icon-ctv-white.svg`),

    IconPlusCircle: require(`${svgs}/icon-plus-circle.svg`),
    IconVoucher: require(`${svgs}/icon-voucher.svg`),
    IconSortDescending: require(`${svgs}/icon-Sort-descending.svg`),

    IconNotification: require(`${svgs}/icon-notification.svg`),
    IconNotificationB: require(`${svgs}/icon-notification-black.svg`),

    // Button Home Page
    IconCalendar: require(`${svgs}/icon-calendar.svg`),
    IconVector: require(`${svgs}/icon-vector.svg`),
    IconPhonePurple: require(`${svgs}/icon-phone-purple.svg`),
    IconBadge: require(`${svgs}/icon-badge.svg`),

    // Personal page
    IconCalendarWhite: require(`${svgs}/icon-calendar-white.svg`),
    IconDollarSquare: require(`${svgs}/icon-dollar-square.svg`),
    IconSort: require(`${svgs}/icon-sort.svg`),
    IconQRCodeWhite: require(`${svgs}/icon-Qrcode-white.svg`),
    IconQRCodeBarcode: require(`${svgs}/icon-scan-barcode.svg`),
    IconEmptyWallet: require(`${svgs}/icon-empty-wallet.svg`),
    IconMoneyReceive: require(`${svgs}/icon-money-receive.svg`),
    IconMoneyReceiveBlack: require(`${svgs}/icon-money-receive-black.svg`),
    IconClipboardList: require(`${svgs}/icon-clipboard-list.svg`),
    IconCreditCard: require(`${svgs}/icon-credit-card.svg`),
    IconHistory: require(`${svgs}/icon-history.svg`),
    IconIdentification: require(`${svgs}/icon-identification.svg`),
    IconLockClosed: require(`${svgs}/icon-lock-closed.svg`),
    IconLogout: require(`${svgs}/icon-logout-on.svg`),
    IconBox: require(`${svgs}/icon-box.svg`),
    IconCameraWhite: require(`${svgs}/icon-Camera-white.svg`),

    IconServiceBlack1: require(`${svgs}/icon-service-black-1.svg`),
    IconServiceBlack2: require(`${svgs}/icon-service-black-2.svg`),
};

const IMAGES = {
    BannerSpa: require(`${images}/banner-spa.png`),
    BannerHome: require(`${images}/banner-home.png`),
    ServiceSpa1: require(`${images}/service-spa-1.png`),
    ServiceSpa2: require(`${images}/service-spa-2.png`),
    ServiceSpa3: require(`${images}/service-spa-3.png`),
    ServiceSpa4: require(`${images}/service-spa-4.png`),
    SpaImg1: require(`${images}/spa-img1.png`),
    SpaImg2: require(`${images}/spa-img2.png`),
    Flower: require(`${images}/flower.png`),
    Flower1: require(`${images}/flower-1.png`),
    Flower2: require(`${images}/flower-2.png`),
    Flower3: require(`${images}/flower-3.png`),
    BackgroundHome: require(`${images}/background-home.png`),
    Image28: require(`${images}/image-28.png`),
    target: require(`${images}/target.png`),
    mission: require(`${images}/mission.png`),
    IntroRight: require(`${images}/intro-img-right.png`),
    NoImage: require(`${images}/no_image.jpg`),
    NewLogo: require(`${images}/newLogo_ms.png`),
    NewLogoCut: require(`${images}/newLogo_ms.png`),
    NewLogoFooter: require(`${images}/newLogo_ms.png`),
    IconCamera: require(`${images}/camera.png`),
    GGPlay: require(`${images}/telegram-cloud-photo-size-5-6336970619295478363-x.jpg`),
    APPStore: require(`${images}/telegram-cloud-photo-size-5-6336970619295478364-x.jpg`),

    IconSkinScreening: require(`${images}/iconSkinScreening.png`),
    QRCodeDownApp: require(`${images}/QRCodeDownApp.png`),

    IconDownloadApp: require(`${images}/iconDownload.png`),

    ImagePlaceholder: require(`${images}/ImagePlaceholder_ms.png`),
    ImageApp: require(`${images}/image_app__.png`),
    ImageLogoOn: require(`${images}/logo_ms.jpeg`),

    ImageBanner01: require(`${images}/banner_01.png`),
    ImageBanner02: require(`${images}/banner_02.png`),
    ImageBanner03: require(`${images}/banner_03.png`),

    ImageLogoGold: require(`${images}/newLogo_ms.png`),

    ImageHomeAppHead: require(`${images}/home_app_head.jpg`),

    ImageBannerServiceProduct: require(`${images}/banner_service_product.png`),
    BannerTopUp: require(`${images}/banner_top_up_ms.jpg`),
    ImageBagCross: require(`${images}/bag-cross.png`),
    ImageTruckTick: require(`${images}/truck-tick.png`),
    ImageEmptyWallet: require(`${images}/empty-wallet.png`),
    ImageEmptyWallet: require(`${images}/empty-wallet.png`),
    ImageDelivery: require(`${images}/delivery.png`),
    ImagedDollarCircleBold: require(`${images}/dollar_circle_bold.png`),
};

const JSON_PATH = {
    DVHCVN: require(`${jsons}/DVHCVN_UPDATED.json`),
};

export { SVGS, IMAGES, JSON_PATH };
// log
